import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const noNeeds = ['No necesitas buscar más información.', 'No necesitas pensar qué hacer.', 'No necesitas esperar el momento perfecto.'];
const includes = ['Un sistema claro para crear contenido', '100 ideas virales listas para publicar', '50 guiones virales listos'];
export function ValueSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-6 bg-dark-secondary" data-id="element-180">
      <div className="max-w-4xl mx-auto" data-id="element-181">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-serif font-bold text-text-primary mb-14 text-center" data-id="element-182">
          Todo lo que necesitas para empezar hoy
        </motion.h2>

        {/* No necesitas... */}
        <div className="max-w-2xl mx-auto space-y-4 mb-12" data-id="element-183">
          {noNeeds.map((item, index) => <motion.p key={index} initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1 + index * 0.1
        }} className="text-lg md:text-xl text-text-secondary text-center" data-id="element-184">
              {item}
            </motion.p>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-xl md:text-2xl text-text-primary font-semibold text-center mb-8" data-id="element-185">
          Aquí ya tienes:
        </motion.p>

        {/* Checkmarks */}
        <div className="max-w-xl mx-auto space-y-4 mb-10" data-id="element-186">
          {includes.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.5 + index * 0.1
        }} className="flex items-center gap-4 p-4 bg-dark-bg/50 rounded-lg border border-accent/15" data-id="element-187">
              <div className="flex items-center justify-center w-8 h-8 bg-accent/15 rounded-full flex-shrink-0" data-id="element-188">
                <CheckIcon className="w-5 h-5 text-accent" data-id="element-189" />
              </div>
              <p className="text-lg text-text-primary font-medium" data-id="element-190">{item}</p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="text-text-secondary text-center text-lg mb-10" data-id="element-191">
          Todo en un solo lugar.
        </motion.p>

        {/* Closing text */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.9
      }} className="text-center" data-id="element-192">
          <p className="text-xl md:text-2xl text-text-secondary mb-2" data-id="element-193">
            Esto no es información…
          </p>
          <p className="text-2xl md:text-3xl font-serif font-bold text-accent" data-id="element-194">
            es el punto donde dejas de pensar y empiezas a hacer.
          </p>
        </motion.div>
      </div>
    </section>;
}